export default __webpack_public_path__ + "media/components/ResultCard/special-needs-c3c4e672ec938bcf66137e63f768e7fe.png";